<template>
  <mce-group :class="$style['adl-line-plot']">
    <mce-path :style="lineStyles" :d="lineCoordinates" />
  </mce-group>
</template>

<script>
import McePath from "@mce/path";
import MceGroup from "@mce/group";
import { line } from "d3-shape";
import { scaleLinear } from "d3-scale";

export default {
  name: "MceLinePlot",
  components: {
    McePath,
    MceGroup,
  },
  props: {
    rangeY: {
      type: Array,
      required: true,
    },
    rangeX: {
      type: Array,
      required: true,
    },
    domainY: {
      type: Array,
      required: true,
    },
    domainX: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    xScale() {
      return scaleLinear().domain(this.domainX).range(this.rangeX);
    },
    yScale() {
      return scaleLinear().domain(this.domainY).range(this.rangeY);
    },
    lineStyles() {
      return {
        stroke: this.color,
        fill: "none",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        opacity: 0.7,
      };
    },
    lineCoordinates() {
      const path = line()
        .x((d) => this.xScale(d.value.x))
        .y((d) => this.yScale(d.value.y));
      return path(this.data);
    },
  },
};
</script>

<style lang="scss" module>
.adl-line-plot {
  shape-rendering: auto;

  &__outline {
    shape-rendering: auto;
  }

  &__dots {
    shape-rendering: auto;
  }

  &__dot {
    shape-rendering: auto;
  }
}
</style>
